import type { components } from "@restomenu/core/types";

export type Me = components["schemas"]["Me"];
export type MeAnonymous = components["schemas"]["MeAnonymous"];
export type MeResponse = Me | MeAnonymous;

/** Опознанный пользователь: вошёл по коду Restoplace. */
export function isAuthenticatedMe(data: MeResponse | undefined): data is Me {
  return data?.type === "user";
}

/** Аноним: сессия есть, ролей нет. Штатное состояние гостя. */
export function isAnonymousMe(
  data: MeResponse | undefined,
): data is MeAnonymous {
  return data?.type === "anonymous";
}
